import { Feature, InjectorService, ToolbarService } from '@tencent/workbench';
import { reaction } from 'mobx';
import BaseToolbarFeature from '@framework/workbench/common/feature/base-toolbar-feature';
import { InsertStateType } from '@editor/src/js/constants/common-action-type';
import { RegionType } from '@src/slide/domain/selection/constant/region';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import {
    TDWActionType,
    TDWModuleType,
    TDWOperationType,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { config } from './config';

@Feature()
export class InsertPlaceFeature extends BaseToolbarFeature {
    public id = config.id;
    public currentPageChangeReaction; // 这个 reaction 没有销毁，但 feature 在 workbench 里是单例的
    public toolbarService;

    public constructor() {
        super();
        this.toolbarService = InjectorService.get(ToolbarService);
        // 切换幻灯片页面类型时更新 toolbar
        this.currentPageChangeReaction = reaction(() => this.getSelectionService().currentSlideType, () => {
            this.toolbarService.$forceUpdate();
        });
    }

    public get curModelIsLayout(): boolean {
        return !!this.getSelectionService().currentSlide?.isLayout;
    }

    public get curModelIsMaster(): boolean {
        return !!this.getSelectionService().currentSlide?.isMaster;
    }

    /**
     * 插入一个元素
     * @param type
     * @param aExtraProps
     */
    public insertElement = (actionId: string): void => {
        if (!this.getSelectionService().currentSlide) return;

        this.getAppService().viewableServiceLayer.editingStateManager.insertState = {
            type: InsertStateType.PLACEHOLDER,
            data: { actionId },
        };

        this.getSelectionService().lastMouseDownRegion = RegionType.EDITOR;
        this.getSelectionService().selectedSlides.clear();

        tdw({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.MASTER,
            action: TDWActionType.INSERT_PLACEHOLDER,
            ver5: actionId,
        });
    };

    protected getCustomDisabledState(): boolean {
        return !this.curModelIsLayout;
    }
}
